// Slick Slider
  $(".multiple-items").slick({
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay:true,
    autoplaySpeed: 2000,
  });

  $(".multiple-items").on('wheel', (function(e) {
    e.preventDefault();

    if (e.originalEvent.wheelDelta / 120 > 0) {
      $(this).slick('slickPrev');
    } else {
      $(this).slick('slickNext');
    }
  }));

  // initial carousel items position
  const slickTrack = 	$('.slick-track');
  slickTrack.addClass('slick-track-position');
  slickTrack.click(function() {
    slickTrack.removeClass('slick-track-position');
  });

  slickTrack.on('wheel', (function (e) {
    slickTrack.removeClass('slick-track-position');
  }));

  // Detecting OS
  const getMobileOS = () => {
    const multipleItems = $('.multiple-items');
    const ua = navigator.userAgent;

    if (/android/i.test(ua)) {
      // console.log('Android')
      mobileCarousel();
    } else if (/iPad|iPhone|iPod/.test(ua) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1){
      // console.log('ios')
      mobileCarousel();
    } else {
      // console.log('Other');
      multipleItems.show();
    }
  }

  const mobileCarousel = () => {
    const featuredRecipes = $('.featured-recipes');
    const multipleItems = $('.multiple-items');
    featuredRecipes.show();
    multipleItems.hide();
  };

  getMobileOS();
